import { render, staticRenderFns } from "./UCHeroGallery.vue?vue&type=template&id=726d2765&scoped=true&"
import script from "./UCHeroGallery.vue?vue&type=script&lang=ts&"
export * from "./UCHeroGallery.vue?vue&type=script&lang=ts&"
import style0 from "./UCHeroGallery.vue?vue&type=style&index=0&id=726d2765&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726d2765",
  null
  
)

export default component.exports